//React
import React from "react"

//Style
import style from "./style.module.scss"

//Images
import Like from "../../images/like.png"
import Shield from "../../images/shield.png"
import Wifi from "../../images/wifi.png"
import sign from "../../images/sign.png"

const Advantag = ({ img, title, text, sign }) => (
  <div className={style.Advantag}>
    <img className={style.img} src={img} alt={title} />
    <h4 className={style.title}>{title}</h4>
    <div className={style.text}>{text}</div>
    {sign ? <img src={sign} className={style.sign} alt="sing" /> : null}
  </div>
)

const items = [
  {
    img: Like,
    title: "Легкість",
    text: "Оплачуй миттєво твоїм гаджетом будь-де, де є позначка",
    sign: sign,
  },
  {
    img: Shield,
    title: "Безпека",
    text:
      "Карткові реквізити не зберігаються на твоєму пристрої та не передаються при оплаті торговцю",
    sign: false,
  },
  {
    img: Wifi,
    title: "Без інтернету",
    text: "При розрахунку технологія не потребує інтернету",
    sign: false,
  },
]

const index = () => {
  return (
    <div className={style.Advantages}>
      {items.map((el, index) => (
        <Advantag key={index} {...el} />
      ))}
    </div>
  )
}

export default index
